import { render, staticRenderFns } from "./AddEditPointModal.vue?vue&type=template&id=4956655b&scoped=true&"
import script from "./AddEditPointModal.vue?vue&type=script&lang=js&"
export * from "./AddEditPointModal.vue?vue&type=script&lang=js&"
import style0 from "./AddEditPointModal.vue?vue&type=style&index=0&id=4956655b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956655b",
  null
  
)

export default component.exports